import React from 'react';

/**
 * Gender Switcher Radio Button component
 */
const GenderSwitcherRadioButton = (props) => (
  <label>
    <input
      type="radio"
      name="nppe2-fc-gender-switcher"
      value={props.value}
      checked={props.selected === props.value}
      onChange={() => props.clicked(
        props.value
      )}
    />
    <div className="nppe2-fc-radio-buttons__label">
      {props.data}
    </div>
  </label>
);

export default GenderSwitcherRadioButton;
